function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "hexagon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M435.279,113.284L247.191,4.692c-10.835-6.257-28.567-6.257-39.402,0L19.701,113.284 C8.865,119.539,0,134.896,0,147.408v217.185c0.843,14.571,8.286,26.639,19.701,34.123l188.088,108.592 c10.835,6.257,28.567,6.257,39.402,0l188.088-108.592c12.248-8.146,19.219-20.408,19.701-34.123V147.408 C454.54,134.243,446.657,120.965,435.279,113.284z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#hexagon)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#centre)",
  x: 222.588,
  y: 124.487,
  width: 267.464,
  height: 273.493
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#bottom)",
  points: "490.052,407.802 145.845,208.63 -29.911,208.63 -29.911,538.353 490.052,538.353"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#top)",
  points: "-29.911,405.093 490.052,104.208 490.052,-14.513 -29.911,-14.513"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "c",
  fill: "#fff",
  d: "M75.83,256.001c-0.891-148.089,197.459-213.479,282.996-75.878l-65.635,37.98 c-39.622-65.534-138.001-42.101-141.532,37.897c1.06,73.729,97.754,107.978,141.536,37.893l65.635,37.979 C283.448,462.735,79.632,415.653,75.83,256.001z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "sharp",
  "aria-label": "\u266F",
  "data-name": "\u266F"
}, /*#__PURE__*/React.createElement("polygon", {
  fill: "#fff",
  points: "326,213 338.5,213 329.959,295.5 317.224,295.5"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#fff",
  points: "352.776,213 365.276,213 356.735,295.5 344,295.5"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 312,
  y: 232.592,
  width: 62.5,
  height: 12.072
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 308.5,
  y: 262,
  width: 62.5,
  height: 12.072
}));

var SvgCSharpLogo = function SvgCSharpLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 500,
    viewBox: "-26 -20 507 552",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "top",
    gradientUnits: "userSpaceOnUse",
    x1: 121.0946,
    y1: 55.8074,
    x2: 261.7725,
    y2: 235.867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A47EDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9866D3"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "centre",
    gradientUnits: "userSpaceOnUse",
    x1: 314.1754,
    y1: 207.291,
    x2: 443.4638,
    y2: 372.7726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B009B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#390086"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottom",
    gradientUnits: "userSpaceOnUse",
    x1: 115.2882,
    y1: 326.1631,
    x2: 252.7405,
    y2: 502.094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#340084"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#290064"
    }
  }))), _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCSharpLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/c-sharp-logo.ff60ab88.svg";
export { ForwardRef as ReactComponent };